import BigNumber from 'bignumber.js';
import { matchaSwapConnector } from '../connectors/swap';
import type { IBuilderReturnData, IMatchaResponse } from '../types';
import { SUSD } from '../addresses';
import type { Token, TokenSymbol } from '$lib/types/tokens';
import { addMargin } from '../connectors/margin';
import type { MarketIdentifiers } from '$lib/types/market';
import { getTokenForAddress } from '$lib/tokensConfig';

export const buildSwapMatchaCalldata = async (
	tokensAllowedForDeposit: Array<TokenSymbol>,
	tokensAllowedForDepositBalance: Record<string, Token>,
	amountPerTokenToSwap: Record<string, BigNumber>,
	matchaCallData: Record<string, IMatchaResponse>,
	marketIdentifier: MarketIdentifiers,
	isAddMaxMargin: boolean = false,
	tokenTo: `0x${string}` = SUSD
): Promise<IBuilderReturnData> => {
	let _targetArray: Array<string> = [];
	let _callDataArray: Array<string> = [];

	if (!matchaCallData || Object.keys(matchaCallData).length == 0) {
		return {
			_callDataArray,
			_targetArray
		};
	}

	let marginAccountedFor: BigNumber = new BigNumber(0);

	for (let i = 0; i < tokensAllowedForDeposit.length; i++) {
		if (tokensAllowedForDeposit[i] === getTokenForAddress(tokenTo)?.symbol) {
			continue;
		}

		const currentToken = amountPerTokenToSwap[tokensAllowedForDeposit[i]];
		const data = matchaCallData[tokensAllowedForDeposit[i]];

		if (!data) {
			continue;
		}

		marginAccountedFor = marginAccountedFor.plus(data.buyAmount);

		try {
			const swapMatchaCallData = await matchaSwapConnector(
				tokensAllowedForDepositBalance[tokensAllowedForDeposit[i]].address as `0x${string}`,
				tokenTo,
				currentToken,
				new BigNumber(0),
				data.data,
				12345
			);
			_targetArray.push(swapMatchaCallData._target);
			_callDataArray.push(swapMatchaCallData._callData);
		} catch (err) {
			console.log(err);
		}

		if (!isAddMaxMargin) {
			const addMarginCallData = await addMargin(marketIdentifier, '0', 12345);

			_targetArray.push(addMarginCallData._target);
			_callDataArray.push(addMarginCallData._callData);
		}
	}

	return {
		_callDataArray,
		_targetArray,
		_changedMargin: marginAccountedFor
	};
};
